import Vue from "vue";

const success = (context, data) => {
  context.isLoading = false;
  context.isCreatedBooking = true;
  context.loading = false;
};

const failed = (context, error) => {
  context.isLoading = false;
  context.loading = false;
  context.bookingDetail.promo_type = null;
  context.bookingDetail.promo_amount = null;
  context.bookingDetail.promo_id = null;
  context.showToasterError(error);
};

export default (context, data) =>
  Vue.$http
    .post("confirm-booking", data)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    })
    .catch((error) => {
      if (error) {
        failed(context, error);
      }
    })
    .finally(() => {
      mixpanel.track("web.calendar.newbooking");
    });



// WEBPACK FOOTER //
// ./src/app/services/booking/confirmBookingPayment.js